import { useState } from "react";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const DIP_PDF = "/dip-lldikti-2026.pdf";

const TABS = [
  {
    id: "wajib",
    label: "Informasi Publik yang Wajib Disediakan Setiap Saat",
    items: [
      [4, "Peta Jalan Reformasi Birokrasi LLDikti"],
      [7, "Peta Proses Bisnis LLDikti"],
      [8, "Peta Jabatan LLDikti"],
      [15, "Data Perbendaharaan di LLDikti"],
      [16, "Peraturan / Keputusan / Kebijakan / Produk Hukum Lainnya yang ditetapkan oleh LLDikti"],
      [17, "Informasi Fasilitasi Penanganan Permasalahan Perguruan Tinggi Swasta di lingkup LLDikti"],
      [18, "Layanan Pengadaan Barang atau Jasa di LLDikti"],
      [21, "Layanan Arsip Dinamis di LLDikti"],
      [23, "Statistik Kepegawaian di LLDikti"],
      [35, "Imbauan Kedisiplinan Pegawai Kantor LLDikti"],
      [38, "Data Akreditasi Perguruan Tinggi Swasta di wilayah LLDikti"],
      [39, "Data Akreditasi Program Studi Perguruan Tinggi Swasta di wilayah LLDikti"],
      [40, "Data Dosen Perguruan Tinggi Swasta di wilayah LLDikti"],
      [41, "Jumlah Mahasiswa Aktif Perguruan Tinggi Swasta (PTS) di wilayah LLDikti"],
      [42, "Rekap Data Pelaporan Laporan Kinerja Dosen / Beban Kerja Dosen"],
      [43, "NIRA (Nomor Induk Registrasi Asesor) di wilayah LLDikti"],
      [44, "Jumlah Rekomendasi Beasiswa Dosen yang dikeluarkan oleh LLDikti"],
      [45, "Daftar Penerima Sertifikasi Dosen di wilayah LLDikti"],
      [46, "Penerima Kartu Indonesia Pintar (KIP) Kuliah di Perguruan Tinggi Swasta di wilayah LLDikti"],
      [47, "Hibah Program Kreativitas Mahasiswa di wilayah LLDikti"],
      [48, "Jumlah Perjanjian Kerja Sama / Nota Kesepahaman di LLDikti"],
      [49, "Pencegahan dan Penanganan Kekerasan Perguruan Tinggi di wilayah LLDikti"],
      [50, "Informasi Satgas Pencegahan dan Penanganan Kekerasan Perguruan Tinggi di wilayah LLDikti"],
    ],
  },
  {
    id: "berkala",
    label: "Informasi Publik yang Disediakan dan Diumumkan Secara Berkala",
    items: [
      [1, "Profil Pimpinan/Pejabat LLDikti"],
      [2, "Organisasi dan Tata Kerja LLDikti"],
      [3, "Struktur Organisasi LLDikti"],
      [5, "Tugas dan Fungsi LLDikti"],
      [6, "Visi dan Misi LLDikti"],
      [9, "Program Kerja LLDikti"],
      [10, "Rencana Strategis LLDikti"],
      [11, "RKAKL dan DIPA LLDikti"],
      [12, "Perjanjian Kinerja LLDikti dengan Kementerian"],
      [13, "Ringkasan Laporan Keuangan LLDikti (Audited)"],
      [14, "Laporan Akuntabilitas Kinerja LLDikti"],
      [19, "Prosedur Peringatan Dini dan Prosedur Evakuasi Keadaan Darurat di LLDikti"],
      [20, "Data Inventaris Barang Milik Negara di LLDikti (Audited)"],
      [24, "Tata Cara Permintaan Informasi Publik di LLDikti"],
      [25, "Tata Cara Keberatan atas Permintaan Informasi Publik di LLDikti"],
      [26, "Tata Cara Pengaduan Penyalahgunaan Wewenang atau Pelanggaran di LLDikti"],
      [27, "Daftar Informasi Publik di LLDikti"],
      [28, "Laporan Akses Informasi Publik di LLDikti"],
      [29, "Hasil Survei Kepuasan Masyarakat di LLDikti"],
      [30, "Data Perguruan Tinggi dan/atau Program Studi di wilayah LLDikti"],
      [31, "Kalender / Agenda Kegiatan di LLDikti"],
      [32, "Daftar Penerima Bantuan Program Penguatan Perguruan Tinggi Swasta"],
      [33, "Daftar Perguruan Tinggi Penerima Hibah Penelitian dan Pengabdian kepada Masyarakat"],
      [36, "Informasi Realisasi Anggaran LLDikti di tahun berjalan"],
      [37, "Laporan harta kekayaan pejabat negara di LLDikti yang telah diumumkan oleh Komisi Pemberantasan Korupsi (KPK)"],
    ],
  },
  {
    id: "serta-merta",
    label: "Informasi Publik yang Diumumkan Secara Serta Merta",
    items: [
      [22, "Penerimaan Calon Aparatur Sipil Negara di LLDikti"],
      [34, "Surat Pemberitahuan Aturan Pakaian Kerja di Lingkungan LLDikti"],
    ],
  },
];

export default function DaftarInformasiPublik() {
  const [active, setActive] = useState("wajib");
  const tab = TABS.find((t) => t.id === active);

  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Layanan Informasi — Daftar Informasi Publik
          </p>
          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            Daftar Informasi Publik
          </h1>
          <p className="mt-4 max-w-2xl text-[15px] text-slate-500 md:text-base">
            Berikut adalah Daftar Informasi Publik (DIP) LLDIKTI Wilayah VII
            Tahun 2026 — Berdasarkan jenis informasi.
          </p>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="dip-tabs"
            className="mt-12 flex flex-wrap gap-2"
            role="tablist"
          >
            {TABS.map((t) => {
              const isActive = active === t.id;
              return (
                <button
                  key={t.id}
                  role="tab"
                  aria-selected={isActive}
                  data-testid={`dip-tab-${t.id}`}
                  onClick={() => setActive(t.id)}
                  className={`rounded-full px-5 py-3 text-left text-[13px] font-semibold transition-colors duration-300 ${isActive ? "bg-[#1479BF] text-white" : "bg-[#F3F7FB] text-slate-600 hover:text-[#1479BF]"}`}
                >
                  {t.label}
                  <span
                    className={`ml-2 rounded-full px-2 py-0.5 text-[10px] ${isActive ? "bg-white/20 text-white" : "bg-white text-[#1479BF]"}`}
                  >
                    {t.items.length}
                  </span>
                </button>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            data-testid={`dip-panel-${tab.id}`}
            className="mt-8 overflow-x-auto rounded-3xl border border-[#E3EBF3]"
          >
            <table
              data-testid="dip-table"
              className="w-full min-w-[720px] border-collapse bg-white text-left text-sm"
            >
              <thead>
                <tr className="bg-[#EFF6FC] text-[#0B2440]">
                  <th className="px-4 py-4 font-bold">No.</th>
                  <th className="px-4 py-4 font-bold">Rangkuman Isi Informasi</th>
                  <th className="px-4 py-4 font-bold">
                    Bentuk Informasi yang Tersedia
                  </th>
                  <th className="px-4 py-4 font-bold">
                    Jangka Waktu Penyimpanan
                  </th>
                </tr>
              </thead>
              <tbody>
                {tab.items.map(([no, title]) => (
                  <tr
                    key={no}
                    data-testid={`dip-row-${no}`}
                    className="border-t border-[#E3EBF3] transition-colors duration-200 hover:bg-[#F3F7FB]"
                  >
                    <td className="px-4 py-4 font-semibold text-[#1479BF]">
                      {no}
                    </td>
                    <td className="px-4 py-4 text-slate-600">{title}</td>
                    <td className="px-4 py-4 text-slate-600">
                      Softcopy / Hardcopy
                    </td>
                    <td className="px-4 py-4 text-slate-600">5 Tahun</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 flex justify-center">
            <a
              href={DIP_PDF}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="dip-download-button"
              className="inline-flex items-center justify-center rounded-full bg-[#0B2440] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#1479BF]"
            >
              UNDUH DIP LLDIKTI 2026 (PDF)
            </a>
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
